import React from "react";
import './index.sass'
import {BuildingBaseData} from "../../index";
import {BuildingCategoryEntry} from "./BuildingCategoryEntry";

import {useTranslationContext} from "../../../react/providers/TranslationContext";

type Props = {
    data: BuildingBaseData[],
    hoverBuilding: BuildingBaseData,
    setHoverBuilding: (gid: BuildingBaseData|null) => void,
    setSelectedBuilding: (gid: number|null) => void,
}

export default function BuildingCategories({data, setSelectedBuilding, hoverBuilding, setHoverBuilding}: Props) {
    const uniqueCategories = [...new Set(data.map(building => building.category))];

    const { translate } = useTranslationContext();

    function buildingSorter(a: BuildingBaseData, b: BuildingBaseData) {
        return translate('building_g' + a.gid).localeCompare(translate('building_g' + b.gid));
    }

    return <div className='categoryContainer'>
        {uniqueCategories.map(category => <div key={category}>
            <div className='categoryHeader'>{translate('category_' + category)}</div>

            <div className='buildingsContainer d-grid gap-1 mt-2' style={{ gridTemplateColumns: '1fr' }}>
                {
                    data
                        .filter(building => building.category === category)
                        .sort(buildingSorter)
                        .map(building =>
                            <BuildingCategoryEntry
                                key={building.gid}
                                building={building}
                                onMouseOver={() => setHoverBuilding(building)}
                                onMouseOut={() => setHoverBuilding(null)}
                                onClick={() => setSelectedBuilding(building.gid)}
                                hoverBuilding={hoverBuilding}
                            />
                        )
                }
            </div>
        </div>)}
    </div>
}

